import React from 'react';
import { SubHeading } from 'web-ui-components/lib/typography/headings';
import { ShellSidebarPanel } from 'web-ui-components/lib/layout/content';
import { PhoneLink } from 'web-ui-components/lib/actions/links';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { Content } from '../../../infrastructure/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';

const NeedHelpSidePanel = () => {
  return (
    <Content>
      {({
        needHelpLabel,
        callUsOnLabel,
        contanctNumberLabel,
        weekdayInfoLabel,
        saturdayInfoLabel,
        sundayInfoLabel
      }) => (
        <ShellSidebarPanel>
          <SubHeading icon={<Icon iconType="Help" />}>
            <span>{needHelpLabel}</span>
          </SubHeading>
          <StandardBody isFlush>
            <span>{callUsOnLabel}</span>
          </StandardBody>
          <StandardBody isFlush>
            <PhoneLink phoneNumber={contanctNumberLabel} />
          </StandardBody>
          <StandardBody>
            <p>{weekdayInfoLabel}</p>
            <p>{saturdayInfoLabel}</p>
            <p>{sundayInfoLabel}</p>
          </StandardBody>
        </ShellSidebarPanel>
      )}
    </Content>
  );
};
export default NeedHelpSidePanel;
